module.exports = __webpack_public_path__ + "img/light-bulb.caa4356a.svg";